import React, { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";
import Tooltip from "./Tooltip";

// Password input with a leading lock icon and a trailing eye toggle.
export default function PasswordInput({
  id,
  value,
  onChange,
  placeholder,
  autoComplete,
  required,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <input
        id={id}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        className="input-base pl-9 pr-10"
      />
      <Tooltip
        label={visible ? "Hide password" : "Show password"}
        className="!absolute right-2 top-1/2 -translate-y-1/2"
      >
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="rounded-md p-1.5 text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-300"
          aria-label={visible ? "Hide password" : "Show password"}
        >
          {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </Tooltip>
    </div>
  );
}
